
export * from './lib/detectYarnLockVersion';
export * from './lib/detectYarnLockVersionByFile';
export { detectYarnLockVersionByObject } from './lib/detectYarnLockVersionByObject';
export { detectYarnLockVersionByParsed } from './lib/detectYarnLockVersionByParsed';

import { detectYarnLockVersion } from './lib/detectYarnLockVersion';

export default detectYarnLockVersion
